<template>
    <div>
        <!-- HEADER -->
        <Header @language-selected="handleLanguageSelected" />
        <!-- HOME PAGE -->

        <section class="container">
            <div class="homepage">
                <div class="homepage-heading">
                    <p>{{ $t("home.header.customer_relationship") }}, <span>{{ $t("home.header.atscale") }}</span></p>
                    <div class="homepage-details">
                        <p style="font-size: 24px;" >{{ $t("home.header.desc2") }}</p>
                        <p style="margin-top: 5px;">{{ $t("home.header.desc1") }}</p>
                        <button class="create-button" @click="handleRedirect">
                            <p>{{ $t("home.header.Createafreeaccount") }}</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" id="arrow">
                                <path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="2" d="M1 7h16M11 1l6 6-6 6" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <!-- <section class="logos">
            <p class="chatwoot_title">{{ $t("home.header.desc2") }}</p>
            <div class="container client_logo_box">
                <div class="client_logo_wrp">
                    <div class="client_logo_box">
                        <img src="../../assets/images/web_page_silder_img(1).jpg" alt="" />
                    </div>
                    <div class="client_logo_box">
                        <img src="../../assets/images/web_page_silder_img(1).jpg" alt="" />
                    </div>
                </div>
            </div>
        </section> -->

        <!-- support Center -->
        <!-- <section class="support-center">
            <div class="container">
                <div class="support-center-heading">
                    <h2>{{ $t("home.header.Omnichannel") }}</h2>
                    <p>{{ $t("home.header.desc3") }}</p>
                    <button class="create-button morelearn" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        {{ $t('headersubmenu.Features.headereLearnMore→') }}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" id="arrow">
                            <path
                                d="M1 26h43.586l-6.293 6.293 1.414 1.414L48.414 25l-8.707-8.707-1.414 1.414L44.586 24H1z" />
                        </svg>
                    </button>
                </div>
                <div class="socialimg">

                    <img :src="require('../../assets/images/socialimg.svg')" alt="socialimg" />
                </div>
            </div>
        </section> -->

        <!-- Customer engagement -->
        <!-- <section class="Customer">
            <div class="container">
                <div class="support-center-heading Customer-heading engament-heading">
                    <h2>{{ $t('home.header.engagementMade') }}</h2>
                    <p>{{ $t("home.header.enablesData") }}</p>
                </div>
                <div class="row"></div>
            </div>
        </section> -->
        <!-- Form -->

        <section class="Alivechat">
            <div class="container">
                <div class="alivechat-details">
                    <div class="absolute inset-0 bg-[url(/grid.svg)] bg-[center 0px] grid-mask linegrid"
                        data-v-8e3a3efa=""></div>
                    <div class="row form-r">
                        <div class="col-lg-6 col-md-6">
                            <div class="Alivechat-form">
                                <form>
                                    <div class="formheading">
                                        <span>{{ $t("feature-live-chat.chat_fits_brand") }}</span>
                                        <p>{{ $t("home.header.desc5") }}</p>
                                    </div>

                                    <div class="greeting">
                                        <label id="greetingmessage">{{ $t("home.header.greetingData") }}</label>
                                        <input type="text" aria-labelledby="greetingmessage" v-model="greetingsTitle" />
                                    </div>
                                    <div class="greeting">
                                        <label id="welcome">{{ $t('doc.AddandConfigure.TableDetails.welcomeTagline') }}</label>
                                        <textarea aria-labelledby="welcome" v-model="greetingsMessage"></textarea>
                                    </div>
                                    <div class="greeting">
                                        <label>{{ $t("home.header.replytime") }}</label>
                                        <select class="form-select" aria-label="Default select example"
                                            v-model="greetingsReplyTime">
                                            <option v-for="data in replyTime" :value="data.id" :key="data.id">
                                                {{ data.title }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="Widgetcolor">
                                        <label for="Widget Color">{{ $t('doc.AddandConfigure.TableDetails.widgetColor') }}</label>
                                        <div class="color">
                                            <input type="color" aria-label="Widget Color" style="
                          border-radius: 0px !important;
                          border: 0.5px solid lightgray !important;
                        " class="appearance-none bg-none form-input block w-full lg:w-1/6 mt-1 h-12 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                data-v-8e3a3efa="" v-model="greetingBGColor" />
                                        </div>
                                    </div>
                                    <div class="radiolable">
                                        <label class="Bubble" for="Widget Bubble position">{{ $t('doc.AddandConfigure.TableDetails.widgetBluePosition') }}</label>
                                        <div class="radio_container">
                                            <input type="radio" name="radio" id="one"
                                                :checked="selectedGreetingBubble === 'left'"
                                                @click="selectedGreetingBubbleClick('left')" />
                                            <label for="one" class="radio_left"> {{ $i18n.locale == 'en' ? 'Left' : '左边' }}</label>
                                            <input type="radio" name="radio" id="two"
                                                :checked="selectedGreetingBubble === 'right'"
                                                @click="selectedGreetingBubbleClick('right')" />
                                            <label for="two" class="radio_right">{{ $i18n.locale == 'en' ? 'Right' : '正确的' }}</label>
                                        </div>
                                    </div>
                                    <div class="radiolable">
                                        <label class="Bubble">{{ $t("home.header.bubbleType") }}</label>
                                        <div class="radio_container Standard_label">
                                            <input type="radio" name="radio1" id="standard"
                                                :checked="selectedGreetingBubbleType === 'Standard'"
                                                @click="selectedGreetingBubbleTypeClick('Standard')" />
                                            <label for="standard" class="radio_left">{{ $t("home.header.Standard") }}</label>
                                            <input type="radio" name="radio1" id="expanded"
                                                :checked="selectedGreetingBubbleType === 'Expanded'"
                                                @click="selectedGreetingBubbleTypeClick('Expanded')" />
                                            <label for="expanded" class="radio_right">{{ $t("home.header.Expanded") }}</label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="form-text">
                                <div class="greeting-title">
                                    <span>{{ greetingsTitle }}</span>
                                    <p>{{ greetingsMessage }}</p>
                                </div>
                                <div class="we-are-online">
                                    <div class="weare">
                                        <div class="weare-heading">
                                            <div class="weare-heading-name">
                                                <span class="weare-live"></span>
                                                <p>{{ $t("home.header.online") }}</p>
                                            </div>
                                            <p class="replie-text">{{ getSelectedFruitName() }}</p>
                                        </div>
                                        <div class="userimage">
                                            <img :src="require('../../assets/images/avatar.webp')" alt="avatar" width="200" height="200">
                                        </div>
                                    </div>
                                    <!-- <button class="Conversation">Start Conversation </button> -->
                                    <button class="Conversation" :style="{ backgroundColor: greetingBGColor }">
                                        {{ $t("home.header.startConversation") }}
                                    </button>
                                </div>
                            </div>
                            <div class="icon-reference">
                                <div class="icon-reference-with-text" :class="
                    selectedGreetingBubble == 'left'
                      ? 'selectedLeft'
                      : isTypeStandard
                      ? 'selectedRight'
                      : 'selectedRightPosition'
                  ">
                                    <p :class="!isTypeStandard ? 'icon-ref' : 'refrence-icon-text'"
                                        :style="{ backgroundColor: greetingBGColor }">
                                        <img src="../../assets/images/becor_white.png" alt="logo21" />
                                        <span :class="!isTypeStandard ? 'd-none' : ''">{{ $t("home.header.chatwithus") }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="checkout">
                    <button class="create-button out-features" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        {{ $t("home.header.checkout") }}
                    </button>
                </div> -->
            </div>
        </section>
        <!-- open-source -->

        <!-- customer conversations -->
        <section class="conversations conversations_box">
            <div class="container">
                <div class="conversations-details" :style="{ backgroundColor: conversationBGColor }">
                    <div class="conversations-heading">
                        <h2>
                            {{ $t(sectionContentTitle) }}
                        </h2>
                    </div>
                    <div class="conversations-tab">
                        <div class="conversation-tab-nav">
                        <ul class="nav nav-pills mb-4 conversation-btn" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('reports')">
                                <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                                    aria-selected="true" :style="{
                    backgroundColor:
                      sectionContent === 'reports' ? 'rgb(31, 147, 255)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true" role="img" class="icon" style="" width="1em" height="1em"
                                        viewBox="0 0 256 256" data-v-ca945699="">
                                        <g fill="currentColor">
                                            <path d="M208 40v168h-56V40Z" opacity=".2"></path>
                                            <path
                                                d="M224 200h-8V40a8 8 0 0 0-8-8h-56a8 8 0 0 0-8 8v40H96a8 8 0 0 0-8 8v40H48a8 8 0 0 0-8 8v64h-8a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16ZM160 48h40v152h-40Zm-56 48h40v104h-40Zm-48 48h32v56H56Z">
                                            </path>
                                        </g>
                                    </svg>{{$t('concepts.reports')}}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('CSAT')">
                                <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-profile" type="button" role="tab"
                                    aria-controls="pills-profile" aria-selected="false" :style="{
                    backgroundColor: sectionContent === 'CSAT' ? 'rgb(99, 102, 241)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true" role="img" class="icon" style="" width="1em" height="1em"
                                        viewBox="0 0 256 256" data-v-ca945699="">
                                        <g fill="currentColor">
                                            <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z" opacity=".2"></path>
                                            <path
                                                d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88a88.1 88.1 0 0 1-88 88ZM80 108a12 12 0 1 1 12 12a12 12 0 0 1-12-12Zm96 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12Zm-1.08 48c-10.29 17.79-27.39 28-46.92 28s-36.63-10.2-46.92-28a8 8 0 1 1 13.84-8c7.47 12.91 19.21 20 33.08 20s25.61-7.1 33.08-20a8 8 0 1 1 13.84 8Z">
                                            </path>
                                        </g>
                                    </svg>{{ $t('conversation.CSAT') }}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('campaigns')">
                                <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-contact" type="button" role="tab"
                                    aria-controls="pills-contact" aria-selected="false" :style="{
                    backgroundColor:
                      sectionContent === 'campaigns' ? 'rgb(20, 184, 166)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true" role="img" class="icon" style="" width="1em" height="1em"
                                        viewBox="0 0 256 256" data-v-ca945699="">
                                        <g fill="currentColor">
                                            <path d="M232 120a40 40 0 0 1-40 40h-40V80h40a40 40 0 0 1 40 40Z"
                                                opacity=".2"></path>
                                            <path
                                                d="M240 120a48.05 48.05 0 0 0-48-48h-39.8c-2.91-.17-53.62-3.74-101.91-44.24A16 16 0 0 0 24 40v160a16 16 0 0 0 26.29 12.25c37.77-31.68 77-40.76 93.71-43.3v31.72a16 16 0 0 0 7.12 13.33l11 7.33A16 16 0 0 0 186.5 212l11.77-44.36A48.07 48.07 0 0 0 240 120ZM40 199.93V40c42.81 35.91 86.63 45 104 47.24v65.48c-17.35 2.28-61.16 11.35-104 47.21Zm131 8v.11l-11-7.33V168h21.6ZM192 152h-32V88h32a32 32 0 1 1 0 64Z">
                                            </path>
                                        </g>
                                    </svg>{{ $t('conversation.Compaigns') }}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('labels')">
                                <button class="nav-link" id="pills-disabled-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-disabled" type="button" role="tab"
                                    aria-controls="pills-disabled" aria-selected="false" :style="{
                    backgroundColor:
                      sectionContent === 'labels' ? 'rgb(244, 63, 94)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        aria-hidden="true" role="img" class="icon" style="" width="1em" height="1em"
                                        viewBox="0 0 256 256" data-v-ca945699="">
                                        <g fill="currentColor">
                                            <path
                                                d="M237.66 153L153 237.66a8 8 0 0 1-11.31 0l-99.35-99.32a8 8 0 0 1-2.34-5.65V40h92.69a8 8 0 0 1 5.65 2.34l99.32 99.32a8 8 0 0 1 0 11.34Z"
                                                opacity=".2"></path>
                                            <path
                                                d="M243.31 136L144 36.69A15.86 15.86 0 0 0 132.69 32H40a8 8 0 0 0-8 8v92.69A15.86 15.86 0 0 0 36.69 144L136 243.31a16 16 0 0 0 22.63 0l84.68-84.68a16 16 0 0 0 0-22.63Zm-96 96L48 132.69V48h84.69L232 147.31ZM96 84a12 12 0 1 1-12-12a12 12 0 0 1 12 12Z">
                                            </path>
                                        </g>
        "Features": {
        "Features": {
                                    </svg>{{ $t('headersubmenu.Features.headerLabels') }}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('automatic')">
                                <button class="nav-link automatic-translation" id="pills-automatic-tab"
                                    data-bs-toggle="pill" data-bs-target="#pills-automatic" type="button" role="tab"
                                    aria-controls="pills-automatic" aria-selected="false" :style="{
                    backgroundColor:
                      sectionContent === 'automatic' ? 'rgb(86, 174, 132)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                        fill="none">
                                        <g id="g_translate_FILL0_wght400_GRAD200_opsz24 1"
                                            clip-path="url(#clip0_964_523)">
                                            <path id="Vector"
                                                d="M7.00033 13.7084L6.32949 11.6958H1.63366C1.2647 11.6958 0.94885 11.5644 0.686107 11.3017C0.423364 11.0389 0.291992 10.723 0.291992 10.3541V1.63272C0.291992 1.26374 0.423364 0.947998 0.686107 0.685498C0.94885 0.422998 1.2647 0.291748 1.63366 0.291748H5.65866L6.24564 2.30436H12.367C12.7583 2.30436 13.0798 2.43016 13.3313 2.68174C13.5829 2.93331 13.7087 3.25477 13.7087 3.6461V12.3674C13.7087 12.7364 13.5829 13.0522 13.3313 13.3147C13.0798 13.5772 12.7583 13.7084 12.367 13.7084H7.00033ZM3.75005 8.75008C4.52226 8.75008 5.15737 8.49973 5.65539 7.99904C6.1534 7.49835 6.40241 6.85425 6.40241 6.06675C6.40241 5.99869 6.39755 5.92821 6.38783 5.85529C6.3781 5.78237 6.36206 5.69244 6.3397 5.5855H3.68991V6.6355H5.19199C5.10229 6.94924 4.93131 7.19296 4.67905 7.36665C4.42678 7.54033 4.12125 7.62716 3.76248 7.62716C3.32521 7.62716 2.95102 7.47034 2.63991 7.15669C2.3288 6.84304 2.17324 6.45658 2.17324 5.99732C2.17324 5.53805 2.32983 5.15043 2.643 4.83446C2.95618 4.51848 3.33088 4.3605 3.76708 4.3605C3.96841 4.3605 4.15722 4.39696 4.33352 4.46987C4.50982 4.54279 4.66959 4.65216 4.81283 4.798L5.64408 4.0105C5.40102 3.75772 5.11583 3.56571 4.7885 3.43446C4.46116 3.30321 4.11441 3.23758 3.74824 3.23758C2.98991 3.23758 2.34824 3.50737 1.82324 4.04696C1.29824 4.58654 1.03574 5.2355 1.03574 5.99383C1.03574 6.75216 1.30067 7.40112 1.83053 7.94071C2.36039 8.48029 3.00023 8.75008 3.75005 8.75008ZM8.23991 9.0855L8.60449 8.72091C8.44894 8.53619 8.30553 8.3539 8.17428 8.17404C8.04303 7.99418 7.91908 7.80216 7.80241 7.598L8.23991 9.0855ZM9.08574 8.22508C9.40095 7.85595 9.64017 7.5036 9.8034 7.16802C9.96663 6.83245 10.0725 6.56744 10.1212 6.373H7.45241L7.65433 7.08758H8.32741C8.41728 7.25486 8.52401 7.43608 8.6476 7.63123C8.77118 7.8264 8.91723 8.02435 9.08574 8.22508ZM7.67116 13.0376H12.367C12.5682 13.0376 12.7304 12.972 12.8533 12.8407C12.9763 12.7095 13.0378 12.5515 13.0378 12.3667V3.64591C13.0378 3.44466 12.9763 3.28255 12.8533 3.15956C12.7303 3.03657 12.5682 2.97508 12.3669 2.97508H6.44616L7.23449 5.68672H8.55958V4.9837H9.24728V5.68672H11.6962V6.373H10.8427C10.7311 6.79105 10.5635 7.20668 10.3399 7.61987C10.1163 8.03307 9.8538 8.4098 9.55241 8.75008L11.3753 10.5438L10.8941 11.0251L9.08574 9.21675L8.47324 9.82925L9.01283 11.6959L7.67116 13.0376Z"
                                                fill="#334155" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_964_523">
                                                <rect width="14" height="14" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>{{ $t("home.header.automatic") }}
                                </button>
                            </li>
                            <li class="nav-item" role="presentation" @click="changeConversationBGColor('Urlchat')">
                                <button class="nav-link UrlchatSvg" id="pills-Urlchat-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-Urlchat" type="button" role="tab"
                                    aria-controls="pills-Urlchat" aria-selected="false" :style="{
                    backgroundColor:
                      sectionContent === 'Urlchat' ? 'rgb(126, 157, 95)' : '',
                  }">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                                        fill="none">
                                        <g id="sms_FILL0_wght400_GRAD0_opsz48 1">
                                            <path id="Vector" class="chat-pathOne"
                                                d="M7.04408 6.373C7.20935 6.373 7.3479 6.3171 7.4597 6.20529C7.57151 6.09348 7.62741 5.95494 7.62741 5.78966C7.62741 5.62439 7.57151 5.48585 7.4597 5.37404C7.3479 5.26223 7.20935 5.20633 7.04408 5.20633C6.8788 5.20633 6.74026 5.26223 6.62845 5.37404C6.51664 5.48585 6.46074 5.62439 6.46074 5.78966C6.46074 5.95494 6.51664 6.09348 6.62845 6.20529C6.74026 6.3171 6.8788 6.373 7.04408 6.373ZM9.52324 6.373C9.68852 6.373 9.82706 6.3171 9.93887 6.20529C10.0507 6.09348 10.1066 5.95494 10.1066 5.78966C10.1066 5.62439 10.0507 5.48585 9.93887 5.37404C9.82706 5.26223 9.68852 5.20633 9.52324 5.20633C9.35796 5.20633 9.21942 5.26223 9.10762 5.37404C8.99581 5.48585 8.93991 5.62439 8.93991 5.78966C8.93991 5.95494 8.99581 6.09348 9.10762 6.20529C9.21942 6.3171 9.35796 6.373 9.52324 6.373ZM1.16699 12.8334V2.04175C1.16699 1.80841 1.25449 1.60425 1.42949 1.42925C1.60449 1.25425 1.80866 1.16675 2.04199 1.16675H11.9587C12.192 1.16675 12.3962 1.25425 12.5712 1.42925C12.7462 1.60425 12.8337 1.80841 12.8337 2.04175V9.62508C12.8337 9.85841 12.7462 10.0626 12.5712 10.2376C12.3962 10.4126 12.192 10.5001 11.9587 10.5001H3.50033L1.16699 12.8334Z"
                                                fill="#B9D0CB" />
                                            <path id="Vector_2" class="chat-pathTwo"
                                                d="M4.46283 6.373C4.6281 6.373 4.76664 6.3171 4.87845 6.20529C4.99026 6.09348 5.04616 5.95494 5.04616 5.78966C5.04616 5.62439 4.99026 5.48585 4.87845 5.37404C4.76664 5.26223 4.6281 5.20633 4.46283 5.20633C4.29755 5.20633 4.15901 5.26223 4.0472 5.37404C3.9354 5.48585 3.87949 5.62439 3.87949 5.78966C3.87949 5.95494 3.9354 6.09348 4.0472 6.20529C4.15901 6.3171 4.29755 6.373 4.46283 6.373ZM7.04408 6.373C7.20935 6.373 7.3479 6.3171 7.4597 6.20529C7.57151 6.09348 7.62741 5.95494 7.62741 5.78966C7.62741 5.62439 7.57151 5.48585 7.4597 5.37404C7.3479 5.26223 7.20935 5.20633 7.04408 5.20633C6.8788 5.20633 6.74026 5.26223 6.62845 5.37404C6.51664 5.48585 6.46074 5.62439 6.46074 5.78966C6.46074 5.95494 6.51664 6.09348 6.62845 6.20529C6.74026 6.3171 6.8788 6.373 7.04408 6.373ZM9.52324 6.373C9.68852 6.373 9.82706 6.3171 9.93887 6.20529C10.0507 6.09348 10.1066 5.95494 10.1066 5.78966C10.1066 5.62439 10.0507 5.48585 9.93887 5.37404C9.82706 5.26223 9.68852 5.20633 9.52324 5.20633C9.35796 5.20633 9.21942 5.26223 9.10762 5.37404C8.99581 5.48585 8.93991 5.62439 8.93991 5.78966C8.93991 5.95494 8.99581 6.09348 9.10762 6.20529C9.21942 6.3171 9.35796 6.373 9.52324 6.373ZM1.16699 12.8334V2.04175C1.16699 1.80841 1.25449 1.60425 1.42949 1.42925C1.60449 1.25425 1.80866 1.16675 2.04199 1.16675H11.9587C12.192 1.16675 12.3962 1.25425 12.5712 1.42925C12.7462 1.60425 12.8337 1.80841 12.8337 2.04175V9.62508C12.8337 9.85841 12.7462 10.0626 12.5712 10.2376C12.3962 10.4126 12.192 10.5001 11.9587 10.5001H3.50033L1.16699 12.8334ZM3.12116 9.62508H11.9587V2.04175H2.04199V10.7917L3.12116 9.62508Z"
                                                fill="#334155" />
                                        </g>
                                    </svg>{{  $t('home.header.urlchat') }}
                                </button>
                            </li>
                        </ul>
                       </div>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-10 col-md-10">
                                            <div class="reports-details">
                                                <span>{{ $t("home.header.informedReport") }}</span>
                                                <p>{{ $t("home.header.desc6") }}</p>
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.converstaionReport") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.agentReport") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.labelsReport") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t('headersubmenu.Features.headerInboxReports') }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.teamReport") }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="reports-img">
<!--                                                <img src="../../assets/images/reports.webp" alt="reports" width="100" height="75" />-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-11 col-md-11">
                                            <div class="reports-details">
                                                <h4>{{ $t("home.header.satisfactionAnlysis") }}</h4>
                                                <p>
                                                    {{ $t("home.header.automaticallyData") }}
                                                </p>
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.automatedFeedback") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.automatedReport") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.usefulFilter") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.usefulFilter") }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="reports-img">
<!--                                                <img src="../../assets/images/csat.webp" alt="csat" />-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-contact" role="tabpanel"
                                aria-labelledby="pills-contact-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-11 col-md-11">
                                            <div class="reports-details">
                                                <h4>{{ $t("home.header.engagementCampign") }}</h4>
                                                <p>
                                                    {{ $t("home.header.ongoingOff") }}
                                                </p>
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.automateCampaigs") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.triggering") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.ScheduleData") }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="reports-img">
<!--                                                <img src="../../assets/images/campaigns.webp" alt="campaigns" />-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-disabled" role="tabpanel"
                                aria-labelledby="pills-disabled-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-11 col-md-11">
                                            <div class="reports-details">
                                                <h4>{{ $t('labels.easy_organize')}}</h4>
                                                <p>
                                                    {{ $t("home.header.customLabel") }}
                                                </p>
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.Customize") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.labelsYour") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.assignmentLabel") }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="reports-img">
<!--                                                <img src="../../assets/images/labels.webp" alt="labels" />-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="pills-automatic" role="tabpanel"
                                aria-labelledby="pills-automatic-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-11 col-md-11">
                                            <div class="reports-details">
                                                <h4>
                                                    {{ $t("home.header.Omni-channel") }}
                                                </h4>
                                                <!-- <p>Create custom labels for your organization in minutes. Simply select relevant labels from your
                          chat's sidebar while chatting with your customers.</p> -->
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t('home.header.safe')  }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{  $t("home.header.fast") }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t("home.header.no_need_to_wait") }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <!-- <div class="reports-img">
                                                <img src="../../assets/images/automatic.png" alt="automatic" />
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-Urlchat" role="tabpanel"
                                aria-labelledby="pills-Urlchat-tab" tabindex="0">
                                <div class="reports">
                                    <div class="row reports-itme">
                                        <div class="col-lg-11 col-md-11">
                                            <div class="reports-details">
                                                <h4>{{ $t("home.header.supports") }}</h4>
                                                <!-- <p>Create custom labels for your organization in minutes. Simply select relevant labels from your
                        chat's sidebar while chatting with your customers.</p> -->
                                                <ul class="reports-ul">
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t('home.header.safe') }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t('home.header.encrypted_chat') }}
                                                    </li>
                                                    <li>
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            aria-hidden="true" role="img" class="icon h-5 w-5 text-woot"
                                                            width="1em" height="1em" viewBox="0 0 256 256"
                                                            data-v-ca945699="">
                                                            <g fill="rgb(31 147 255)">
                                                                <path d="M224 128a96 96 0 1 1-96-96a96 96 0 0 1 96 96Z"
                                                                    opacity=".2"></path>
                                                                <path
                                                                    d="M173.66 98.34a8 8 0 0 1 0 11.32l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 0ZM232 128A104 104 0 1 1 128 24a104.11 104.11 0 0 1 104 104Zm-16 0a88 88 0 1 0-88 88a88.1 88.1 0 0 0 88-88Z">
                                                                </path>
                                                            </g>
                                                        </svg>{{ $t('home.header.timely_response') }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <!-- <div class="reports-img">
                                                <img src="../../assets/images/Urlchat.png" alt="urlchat" />
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- review -->
        <!-- Customer interaction Start -->
        <div class="container">
            <div class="customer-box" style="margin-top:10px;">
                <div class="row row-gap-5">
                    <div class="col-lg-6 col-md-6">
                        <div class="interaction-title Customer-interaction d-flex flex-column h-100 p-lg-5">
                            <h3>{{ $t("home.header.interactionCustomer") }}</h3>
                            <div>
                                <p>
                                    {{ $t("home.header.conversationsBcoor") }}
                                </p>
                                <div
                                class="d-flex flex-wrap justify-content-lg-start align-items-center app-btn gap-3 appicon">
                                    <!-- <a href="javascript:void(0);"> -->
                                    <div @click="downloadFile('ios')">
                                        <img src="../../assets/images/app-store.png" class="app-download-link" alt="img" width="170" height="50"/>
                                    </div>
                                    <!-- </a> -->
                                    <!-- <a href="javascript:void(0);"> -->
                                    <div @click="downloadFile('android')">
                                        <img src="../../assets/images/play-store.png" class="app-download-link" alt="img" width="170" height="50"/>
                                        <!-- <p class="m-0 pt-1 download-apk">{{ $t("home.header.downloadApk") }}</p> -->
                                    </div>
                                    <!-- </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 position-relative customer-app-box">
                        <div class="round-svg">
                            <svg viewBox="0 0 1026 1026" fill="none" aria-hidden="true"
                                class="absolute inset-0 h-full w-full animate-spin-slow" data-v-1d09e88b="">
                                <path
                                    d="M1025 513c0 282.77-229.23 512-512 512S1 795.77 1 513 230.23 1 513 1s512 229.23 512 512Z"
                                    stroke="#313F55" stroke-opacity="0.7" data-v-1d09e88b=""></path>
                                <path d="M513 1025C230.23 1025 1 795.77 1 513" stroke="url(#:R65m:-gradient-1)"
                                    stroke-linecap="round" data-v-1d09e88b=""></path>
                                <defs data-v-1d09e88b="">
                                    <linearGradient id=":R65m:-gradient-1" x1="1" y1="513" x2="1" y2="1025"
                                        gradientUnits="userSpaceOnUse" data-v-1d09e88b="">
                                        <stop stop-color="#06b6d4" data-v-1d09e88b=""></stop>
                                        <stop offset="1" stop-color="#06b6d4" stop-opacity="0" data-v-1d09e88b="">
                                        </stop>
                                    </linearGradient>
                                </defs>
                            </svg>
                            <svg viewBox="0 0 1026 1026" fill="none" aria-hidden="true"
                                class="absolute inset-0 h-full w-full animate-spin-reverse-slower" data-v-1d09e88b="">
                                <path
                                    d="M913 513c0 220.914-179.086 400-400 400S113 733.914 113 513s179.086-400 400-400 400 179.086 400 400Z"
                                    stroke="#313F55" stroke-opacity="0.7" data-v-1d09e88b=""></path>
                                <path d="M913 513c0 220.914-179.086 400-400 400" stroke="url(#:R65m:-gradient-2)"
                                    stroke-linecap="round" data-v-1d09e88b=""></path>
                                <defs data-v-1d09e88b="">
                                    <linearGradient id=":R65m:-gradient-2" x1="913" y1="513" x2="913" y2="913"
                                        gradientUnits="userSpaceOnUse" data-v-1d09e88b="">
                                        <stop stop-color="#06b6d4" data-v-1d09e88b=""></stop>
                                        <stop offset="1" stop-color="#06b6d4" stop-opacity="0" data-v-1d09e88b="">
                                        </stop>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>

                        <div class="app-img">
                            <!-- <img src="../../assets/images/app-img.webp" alt="img" width="315"/> -->
                            <img src="../../assets/images/app-img.webp" style="object-fit: contain; object-position: bottom" alt="img" width="315" height="200" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer :selectLanguage="selectLanguage" />
    </div>
    <!-- Customer interaction End -->

    <!-- Footer Start -->
</template>
<script>
    import Footer from "@/views/chatwoot/Footer.vue";
    import Header from "@/views/chatwoot/Header.vue";

    export default {
        name: "Home",
        data() {
            return {
                greetingsTitle: this.$i18n.locale == 'en' ? "Hello there 👋" :  "你好 👋",
                greetingsMessage:
                this.$i18n.locale == 'en' ? "We are here to help you with your questions. Ask us anything, or share your feedback." : "我们在这里帮助您解答问题。随时提出问题或分享您的反馈。",
                greetingsReplyTime: 1,
                replyTime: [
                    {
                        id: 1,
                        title: this.$i18n.locale == 'en' ? "In a few minutes" :  "几分钟内",
                        message: this.$i18n.locale == 'en' ? "Typically replies in a few minutes" : "通常在几分钟内回复",
                    },
                    { id: 2, title: this.$i18n.locale == 'en' ? "In a few hours" : "几小时内", message: this.$i18n.locale == 'en' ? "Typically replies in a few hours" : "通常在几小时内回复" },
                    { id: 3, title: this.$i18n.locale == 'en' ? "In a day" : "一天内", message: this.$i18n.locale == 'en' ? "Typically replies in a day" : "通常在一天内回复"  },
                ],
                selectedGreetingBubble: "left",
                selectedGreetingBubbleType: "Standard",
                greetingBGColor: "#1F93FF",
                conversationBGColor: "rgb(240, 249, 255)",
                sectionContent: "reports",
                isTypeStandard: false,
                divOpen: false,
                responsiveDiv: false,
                view: {
                    topOfPage: true,
                },
                sectionContentTitle: "home.header.informedReport",
                selectLanguage: 'en',
            };
        },
        components: {
            Footer,
            Header,
        },

        beforeMount() {
            window.addEventListener("scroll", this.handleScroll);
            localStorage.setItem("isActive", "product");
        },

        methods: {
            toggleOpen() {
                this.divOpen = !this.divOpen;
            },
            responsiveMethod() {
                this.responsiveDiv = !this.responsiveDiv;
            },
            handleScroll() {
                if (window.pageYOffset > 0) {
                    if (this.view.topOfPage) this.view.topOfPage = false;
                } else {
                    if (!this.view.topOfPage) this.view.topOfPage = true;
                }
            },
            getSelectedFruitName() {
                const greetingsReplyTime = this.replyTime.find(
                    (element) => element.id === parseInt(this.greetingsReplyTime)
                );
                return greetingsReplyTime ? greetingsReplyTime.message : "";
            },
            selectedGreetingBubbleClick(option) {
                this.selectedGreetingBubble = option;
            },
            selectedGreetingBubbleTypeClick(option) {
                this.selectedGreetingBubbleType = option;
                this.isTypeStandard = this.selectedGreetingBubbleType == "Standard" ? false : true;
            },
            changeConversationBGColor(section) {
                this.sectionContent = section;
                if (section == "reports") {
                    this.conversationBGColor = "rgb(240, 249, 255)";
                    this.sectionContentTitle = 'home.header.informedReport'
                } else if (section == "CSAT") {
                    this.conversationBGColor = "rgb(238, 242, 255)";
                    this.sectionContentTitle = 'home.header.satisfactionAnlysis'
                } else if (section == "campaigns") {
                    this.conversationBGColor = "rgb(240, 253, 250)";
                    this.sectionContentTitle = 'home.header.engagementCampign'
                } else if (section == "labels") {
                    this.conversationBGColor = "rgb(255, 241, 242)";
                    this.sectionContentTitle = 'labels.easy_organize'
                } else if (section == "automatic") {
                    this.conversationBGColor = "rgb(233, 253, 243)";
                    this.sectionContentTitle = 'home.header.Omni-channel'
                } else if (section == "Urlchat") {
                    this.conversationBGColor = "rgb(239, 250, 227)";
                    this.sectionContentTitle = 'home.header.supports'
                }
            },
            handleRedirect() {
                window.location.href = 'https://app.bcoor.com/app/auth/signup'
            },
            handleLanguageSelected (language) {
                this.selectLanguage = language;
            },
            downloadFile (type) {
                if(type == 'android'){
                    let url = "https://download.bcoor.com/download/Androidapk/Bcoor%E5%85%8D%E8%B4%B9%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D%E7%B3%BB%E7%BB%9F.apk"
                    const a = document.createElement('a')
                    a.href = url
                    a.download = url.split('/').pop()
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                }else if(type == 'ios'){
                    window.open("https://apps.apple.com/app/bcoor在线客服/id6499088891")
                }
            },
        },

      created() {
        const localStorageItem = localStorage.getItem('language');

        if (localStorageItem) {
            
            this.selectLanguage = localStorageItem;
        }
      }
    };

// $(window).scroll(function() {

//     var scroll = $(window).scrollTop();

//     if (scroll >= 500) {
//         $(".homepage-header").addClass("darkHeader");
//     } else {
//         $(".homepage-header").removeClass("darkHeader");
//     }
// });
</script>

<style>
    .selectedLeft {
        left: 0;
    }

    .selectedRight {
        right: 0px;
    }

    .selectedRightPosition {
        right: 60px;
    }

    .d-none {
        display: none;
    }

    .download-apk {
        font-size: 16px !important;
        text-align: center
    }

    @media screen and (max-width : 1199px) {
        .download-apk {
        font-size: 12px !important;
        }
    }

    .app-download-link {
        cursor: pointer;
    }

    .app-download-link:hover {
        transform: scale(1.04);
        transition: all .2s;
    }
</style>